import React from 'react';
import { Modal } from "react-bootstrap";
import { NavLink } from 'react-router-dom';
import ErrorMessage from './ErrorMessage';


const CreateReserveAccount = ({show, action: {action, error, actedOn, data}, onHide}) => {

    return <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Modal.Header >
              <Modal.Title id="contained-modal-title-vcenter">
              <i class="flaticon2-layers-2 text-primary mr-2"></i> {action}
              </Modal.Title>
              <button type="button" className="close" onClick={onHide}>
                  <span aria-hidden="true" className="d-block">×</span>
                  <span className="sr-only">Close</span>
               </button>
            </Modal.Header>
            <Modal.Body>
                <ErrorMessage {...{error}} />
                <div className="px-md-5">
                    <div className="row">
                        <div className="col-md-4 h6">
                            User
                        </div>
                        <div className="col-md h6 text-muted">
                            <NavLink to={`/users/view/${data.meta?.userId}`} target="_blank" >
                                {`${data.meta?.firstName ?? ""} ${data.meta?.lastName ?? ""}`}
                            </NavLink>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                            Email
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.meta?.email}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                            Account Id
                        </div>
                        <div className="col-md h6 text-muted">
                            <NavLink to={`/users/view/${data?.userId}/account-information/${data?.accountId}`} className="text-muted text-hover-primary" target="_blank" >
                                {data?.accountId}
                            </NavLink>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                            Gateway
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.gateway?.toUpperCase()}
                        </div>
                    </div>
                </div>    
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-5"
                >
                    Okay
                </button>
            </Modal.Footer>
          </Modal>
}

export default CreateReserveAccount;